import React from "react";
import SingleRecord from "../SingleRecord/SingleRecord";
import User from "../Users/User";
import CreateTable from "../ControlEngine/CreateTable";
import CreateMenu from "../ControlEngine/CreateMenu";
import getExtendedOgDefs from "../../TableDefinitions/extendedOgDef";
const getEditView = (
  tableName,
  cancelHandler,
  deleteHandler,
  createTableList,
  genNotification
) => {
  let ogTableDef = getExtendedOgDefs(createTableList);
  //console.log("opening edit view");
  if (tableName === "attendance") {
    return (
      <div>
        <Attendance
          path={tableName}
          handleEditCancel={cancelHandler}
          handleDelete={deleteHandler}
          ogTableDef={ogTableDef}
          genNotification={genNotification}
        />
      </div>
    );
  } else if (tableName === "projectInvoices") {
    return (
      <div>
        <Invoices
          path={tableName}
          handleEditCancel={cancelHandler}
          handleDelete={deleteHandler}
          ogTableDef={ogTableDef}
          genNotification={genNotification}
        />
      </div>
    );
  } else if (tableName === "projectQuotes") {
  } else if (tableName === "accountEnquiry") {
    return (
      <div>
        <AccountEnquiry
          path={tableName}
          handleEditCancel={cancelHandler}
          handleDelete={deleteHandler}
          ogTableDef={ogTableDef}
          genNotification={genNotification}
        />
      </div>
    );
  } else if (tableName === "projectQuotes") {
    return (
      <div>
        <Quotations
          path={tableName}
          handleEditCancel={cancelHandler}
          handleDelete={deleteHandler}
          ogTableDef={ogTableDef}
          genNotification={genNotification}
        />
      </div>
    );
  } else if (tableName === "projectPos") {
    return (
      <div>
        <PurchaseOrders
          path={tableName}
          handleEditCancel={cancelHandler}
          handleDelete={deleteHandler}
          ogTableDef={ogTableDef}
          genNotification={genNotification}
        />
      </div>
    );
  } else if (tableName === "projectDos") {
    return (
      <div>
        <DeliveryOrders
          path={tableName}
          handleEditCancel={cancelHandler}
          handleDelete={deleteHandler}
          ogTableDef={ogTableDef}
          genNotification={genNotification}
        />
      </div>
    );
  } else if (tableName === "users") {
    return (
      <div>
        <User
          path={tableName}
          handleEditCancel={cancelHandler}
          handleDelete={deleteHandler}
          ogTableDef={ogTableDef}
          genNotification={genNotification}
        />
      </div>
    );
  } else if (tableName === "projectQuotes") {
    return (
      <div>
        <Quotations
          path={tableName}
          handleEditCancel={cancelHandler}
          handleDelete={deleteHandler}
          ogTableDef={ogTableDef}
          genNotification={genNotification}
        />
      </div>
    );
  } else if (tableName === "reports") {
    return (
      <div>
        <ReportBuilder
          path={tableName}
          handleEditCancel={cancelHandler}
          handleDelete={deleteHandler}
          ogTableDef={ogTableDef}
        />
      </div>
    );
  } else if (tableName === "createTable") {
    return (
      <div>
        <CreateTable
          path={tableName}
          handleEditCancel={cancelHandler}
          handleDelete={deleteHandler}
          ogTableDef={ogTableDef}
        />
      </div>
    );
  } else if (tableName === "menuDesigner") {
    return (
      <div>
        <CreateMenu
          path={tableName}
          handleEditCancel={cancelHandler}
          handleDelete={deleteHandler}
          ogTableDef={ogTableDef}
        />
      </div>
    );
  } else {
    return (
      <div>
        <SingleRecord
          path={tableName}
          handleEditCancel={cancelHandler}
          handleDelete={deleteHandler}
          ogTableDef={ogTableDef}
          genNotification={genNotification}
        />
      </div>
    );
  }
};

export default getEditView;



// WEBPACK FOOTER //
// ./src/app/components/Screens/landingPage/getEditView.jsx